module.exports = __webpack_public_path__ + "6fc7fc9e81d85931fea438b46929645b.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/manage-application/remote-app-access/remove/remove-remote-app.html
// module id = 1613
// module chunks = 0